<script>
import CarItem from '@/components/carListItem.vue'
import { getDateformat } from '@/util/getDate.js'
import TableCommon from "@/components/table.vue";

export default {
  components: {
    TableCommon,
    CarItem
  },
  data() {
    return {
      getDateformat,
      order_id: null,
      order_info: {
        extend_order_goods: [],
        supplier_info: {},
        extend_order_extend: {
          reciver_infos: {
            combine_detail: '',
            address: ''
          }
        },
        extend_user: {
          mobile: '',
          vip_info: {
            member_level_end_time: '',
            member_level_name: ''
          }
        },
        extend_order_pay: {
          pay_state: ''
        }
      },
      getDateformat,
      payment_code: {
        '10': '微信支付', '20': '支付宝支付', '30': '华为支付', '40': '余额支付', '50': '会员卡支付', '60': '抖音支付', '70': '百度支付', '80': '银行转账'
      },
      order_status: {
        0: "已取消",
        10: "待支付",
        20: "待发货",
        30: "待收货",
        40: "已完成",
        50: "尾款支付",
      },
      order_type: {
        0: "普通订单",
        1: "特价订单",
        2: "套餐订单",
      },
      breakdown_status: [
        { status: 'PENDING', name: '待处理' },
        { status: 'PROCESSING', name: '处理中' },
        { status: 'SUCCESS', name: '分账成功' },
        { status: 'FAIL', name: '分账失败' },
      ],
      goods_table_config: [
        { key: 'goods_info', label: '商品信息', type: 'slot', width: '250px' },
        { key: 'spu_code', label: '商品编号', type: 'slot' },
        { key: 'price', header:1, type: 'slot' },
        { key: 'discount_pay_price', label: '商品优惠金额', type: 'slot' },
        { key: 'deposit', label: '定金比例', type: 'slot' },
        { key: 'deposit_price', label: '定金应付金额', type: 'slot' },
        { key: 'goods_pay_price', label: '商品应付金额', type: 'slot' },
        { key: 'split_total_amount', label: '分账金额', type: 'slot' },
        { key: 'splitting_rate', label: '分账比例', type: 'slot' },
      ]
    };
  },
  created() {
    this.order_id = this.$route.params.id
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail() {
      this.$axios.post(this.$api.order.info, {
        id: this.order_id
      }).then(res => {
        if (res.code == 0) {
          let is_vip = res.result.info.extend_user.is_chache_vip
          res.result.info.extend_order_goods.forEach(g => {
            if (!g.package_id) g.item_info.last_raise_price = is_vip ? g.item_info.vip_raise_price : g.item_info.raise_price
          })
          this.order_info = res.result.info
        }
      })
    },
    getBreakdownStatus() {
      return this.breakdown_status.find(o => o.status == this.order_info.split_status)?.name || '--'
    },
  },
}
</script>
<template>
  <el-main>
    <div class="page_title">订单详情</div>
    <div class="content_area_box">
      <div class="content_title">订单基础信息</div>
      <div class="content_grid">
        <div class="content_grid_item">订单编号 ：{{ order_info.pay_sn }}</div>
        <div class="content_grid_item">所属商家 ：{{ order_info.supplier_info.store_name }}</div>
        <div class="content_grid_item">订单类型 ：{{ order_type[order_info.order_type] }}</div>
        <div class="content_grid_item">下单时间 ：{{ getDateformat(order_info.create_time) }}</div>
        <div class="content_grid_item">订单状态 ：{{ order_status[order_info.state] }}</div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">订单分账信息</div>
      <div class="content_grid">
        <div class="content_grid_item">分账金额 ：¥{{ order_info.split_total_amount }}</div>
        <div class="content_grid_item">分账状态 ：{{ getBreakdownStatus() }}</div>
        <div class="content_grid_item" v-if="order_info.split_time">分账时间
          ：{{ order_info.split_time ? getDateformat(order_info.split_time) : '--' }}</div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">订单支付信息</div>
      <div class="content_grid">
        <div class="content_grid_item">支付状态 ：{{ order_info.extend_order_pay.pay_state ? '已支付' : '待支付' }}</div>
        <div class="content_grid_item">支付方式 ：{{payment_code[order_info.payment_code] || '--'}}</div>
        <div class="content_grid_item">支付时间 ：{{order_info.payment_time ? getDateformat(order_info.payment_time) : '--'}}
        </div>
        <div class="content_grid_item" v-if="order_info.state <= 10">订单实付金额 ：¥0.00</div>
        <div class="content_grid_item" v-if="order_info.state == 50">订单实付金额 ：¥{{ order_info.deposit_price }}</div>
        <div class="content_grid_item" v-else>订单实付金额
          ：¥{{ Number(order_info.revise_amount) ? order_info.revise_amount : (Number(order_info.real_pay_price) + Number(order_info.final_payment_amount) + Number(order_info.tax_price)).toFixed(2) }}
        </div>
        <div class="content_grid_item">商品总金额
          ：¥{{ (Number(order_info.goods_amount)).toFixed(2) }}</div>
        <div class="content_grid_item" v-if="order_info.state <= 10 || Number(order_info.final_payment_amount) == 0">
          订金实付金额 ：¥0.00</div>
        <div class="content_grid_item" v-else>订金实付金额 ：¥{{ order_info.deposit_price }}</div>
        <div class="content_grid_item">商品优惠金额 ：¥{{ order_info.discount_pay_price }}</div>
        <div class="content_grid_item">开票税费 ：¥{{ order_info.tax_price }}</div>
      </div>
    </div>
    <div class="content_area_box">
      <div class="content_title">商品信息</div>
      <div style="height:20px"></div>
      <TableCommon :data="order_info.extend_order_goods" :table_config="goods_table_config">
        <template #goods_info="{ row }">
          <CarItem v-if="!row.package_id" :car="row.item_info" height="66px"></CarItem>
          <div v-if="row.package_id">
            <div v-for="(item,index) in row.package_item_list" :key="index">
              <CarItem :car="item" height="66px"></CarItem>
            </div>
          </div>
        </template>
        <template #spu_code="{ row }">
          <div v-if="!row.package_id">{{ row.item_info.spu_code }}</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center" v-for="(item,index) in row.package_item_list" :key="index">
              {{ item.spu_code }}
            </div>
          </div>
        </template>
        <template #h_price="{ row }">
          {{ order_info.extend_user.is_chache_vip ? '会员价' : '零售价' }}
        </template>
        <template #price="{ row }">
          <div v-if="!row.package_id">¥{{ order_info.extend_user.is_chache_vip ? row.item_info.original_price :  row.item_info.price }}</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center" v-for="(item,index) in row.package_item_list" :key="index">
              ¥{{ item.price }}
            </div>
          </div>
        </template>
        <template #discount_pay_price="{ row }">
          <div v-if="!row.package_id">¥{{ row.discount_pay_price }}</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center" v-for="(item,index) in row.package_item_list" :key="index">
              ¥{{ Number(item.discount_price).toFixed(2) }}
            </div>
          </div>
        </template>
        <template #deposit="{ row }">
          <div v-if="!row.package_id">{{ Number(row.item_info.deposit) * 100 }}%</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center">--</div>
          </div>
        </template>
        <template #deposit_price="{ row }">
          <div v-if="!row.package_id">
            {{ Number(row.deposit_price).toFixed(2)}}</div>
          <div v-if="row.package_id" class="cell_c_info">
            <div class="cell_row center">--</div>
          </div>
        </template>
        <template #goods_pay_price="{ row }">
          <div> {{ row.goods_price }}</div>
        </template>
        <template #split_total_amount="{ row }">¥{{ row.split_infos.total_amount }}</template>
        <template #splitting_rate="{ row }">{{ Number(row.split_infos.splitting_rate) * 100 }}%</template>
      </TableCommon>
    </div>
  </el-main>
</template>
<style lang="less" scoped>
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
  .page_title {
    padding-bottom: 10px;
    border-bottom: 1px solid #e6e6e6;
  }
  .content_area_box {
    width: 100%;
    font-weight: bold;
    margin-top: 25px;
    max-width: 1000px;
    &:last-child {
      max-width: 1400px;
    }
    .content_title {
      font-size: 16px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 6px;
        height: 14px;
        background: #409eff;
      }
    }
    .content_grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      font-size: 14px;
      font-weight: normal;
      margin-top: 14px;
      padding-left: 14px;
    }
  }
}
.cell_c_info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .cell_row {
    flex: 1;
  }
}
.content_area_box /deep/ .cellStyle {
  height: 1px;
  .center {
    height: 100%;
    flex-direction: column;
  }
  .cell {
    height: 100%;
  }
}
</style>